var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCreditScore = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 44,
    viewBox: "0 0 75 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.805 33.022V0c-9.83.19-18.734 4.4-25.322 11.15l21.964 23.352a6.266 6.266 0 0 1 3.358-1.483v.003z",
    fill: "#F6921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 39.859h31.03a7.11 7.11 0 0 1 1.432-4.31L10.5 12.196C3.998 19.367 0 29.116 0 39.86z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.556 34.505 21.963-23.351C56.93 4.402 48.024.192 38.195 0v33.022a6.227 6.227 0 0 1 3.358 1.483h.003z",
    fill: "#D7DF23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 39.859c0-10.743-3.998-20.492-10.499-27.662L42.538 35.548a7.127 7.127 0 0 1 1.432 4.311H75z",
    fill: "#009C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.345 40.481 5.595-25.008L34.356 37.42c-.18.261-.337.548-.459.863-.82 2.114.13 4.535 2.118 5.404 1.988.869 4.265-.138 5.082-2.252.122-.312.2-.633.246-.955h.002zm-4.69 1.566c-1.136-.496-1.679-1.878-1.21-3.086.467-1.207 1.768-1.78 2.903-1.285 1.136.497 1.678 1.879 1.209 3.086-.467 1.208-1.767 1.781-2.903 1.285z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.088 40.553c-.362.932-1.365 1.377-2.24.992-.876-.384-1.294-1.45-.933-2.383.362-.932 1.365-1.377 2.242-.992.877.384 1.295 1.451.933 2.383h-.002z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.56 8.025c-.742 1.514-1.212 3.146-1.81 4.723-.19.502.512.9.703.396.6-1.577 1.069-3.212 1.81-4.727.238-.484-.466-.88-.704-.395v.003zM43.963 10.02a15.852 15.852 0 0 0 1.084 3.173c.228.49 1.035.223.805-.273a15.852 15.852 0 0 1-1.085-3.172c-.12-.533-.925-.255-.804.273zM52.608 14.086c-1.044.253-2.053.66-3.06 1.09-.488.208-.19 1.143.295.935.941-.4 1.883-.789 2.859-1.024.502-.123.41-1.124-.092-1h-.002z",
    fill: "#1E2969"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCreditScore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-credit-score.18745d4dca4f14a3c3783253704be14f.svg";